import React, {Component} from 'react';
import PrintPreview from '../PrintPreview'
import ReportStore from 'stores/ReportStore'
import './Print.css'

const DEFAULT_ROW = 31
class PrintReportPostPayment extends Component {

    constructor(...args) {
      super(...args)
        
      this.state = {loading:false,dataList:[],data:[],report_title:'กำลังดึงข้อมูล..'}

      var cssPagedMedia = (function() {
        var style = document.createElement('style');
        document.head.appendChild(style);
        return function (rule) {
          style.innerHTML = rule;
        };
      }());
  
      cssPagedMedia.size = function(size) {
        cssPagedMedia('@page {size: ' + size + '}');
      };
      cssPagedMedia.size('landscape');
    }

    componentDidMount() {
        this.loadData()
    }

    loadData() {
        if (this.props.isRange=='false'&&this.props.year!=undefined&&this.props.month!=undefined&&this.props.day!=undefined&&this.props.name!=undefined) {
            ReportStore.loadReportPostPayment(this.props.year,this.props.month,this.props.day,this.props.name,(result)=>{
                this.setState({data:result.data,dataList:this.getPagination(result.data),report_title:'ไม่พบข้อมูล'})
            },()=>{

            })   
        } else if (this.props.isRange=='true'&&this.props.startDate!=undefined&&this.props.endDate!=undefined&&this.props.name!=undefined) {
            ReportStore.loadReportPostPaymentRange(this.props.startDate,this.props.endDate,this.props.name,(result)=>{
                this.setState({data:result.data,dataList:this.getPagination(result.data),report_title:'ไม่พบข้อมูล'})
            },()=>{
                
            })
        } else {
            this.setState({data:[],dataList:this.getPagination([]),report_title:'ไม่พบข้อมูล'})
        }
    }

    getNumberFormat(value) {
        let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
        _val = parseFloat(_val)
        return _val.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
    }
    
    getSummary(field) {
        let {data} = this.state
        let total = 0
        data.forEach((item,index)=> {
            total += (item[field]===''||item[field]===null||item[field]===undefined||isNaN(item[field])?0:item[field]*1)
        }) 
        return total
    }

    getPagination(data) {
        let newData = []
        let allData = []
        let checkRow = 0
        data.forEach(function(item,index) {
            if (checkRow<DEFAULT_ROW)
              checkRow++
              newData.push(item)
    
            if (checkRow===DEFAULT_ROW-1||index===data.length-1) {
              allData.push(newData)
              checkRow = 0
              newData = []
            }
        })  
        
        return allData
    }

    renderRowData(data,indexs) {
        if (data.length==0) {
          return(<tr><td colSpan={11}>ไม่พบข้อมูล</td></tr>)
        } else {
          return data.map((item, index) => (
            <tr key={index}>
              <td className='text-center'>{item.payment_date}</td>
              <td className='text-center'>{item.doc_type_text}</td>
              <td className='text-center'>{item.doc_no}</td>
              <td className='text-center'>{item.work_no}</td>
              <td className='text-center'>{item.car_registration_no}</td>
              <td className='text-center'>{item.brand}</td>
              <td className='text-center'>{item.model}</td>
              <td className='text-center'>{item.customer_name}</td>
              <td className='text-right'>{this.getNumberFormat(item.amount)}</td>
              <td className='text-right'>{this.getNumberFormat(item.approved_amount)}</td>
              <td className='text-right'>{this.getNumberFormat(item.payment_amount)}</td>
            </tr>
          ))
        }
    }

    renderTable(item,index,length) {
        // let {type} = this.props
        return(
            <table className='table table-print-report-sales-tax'>
                <tbody>
                    <tr>
                        <td className='text-center' style={{minWidth:'100px',width:'100px'}}>วันที่ชำระเงิน</td>
                        <td className='text-center' style={{minWidth:'100px',width:'100px'}}>ประเภท</td>
                        <td className='text-center' style={{minWidth:'100px',width:'100px'}}>เลขเอกสาร</td>
                        <td className='text-center' style={{minWidth:'100px',width:'100px'}}>ใบงานเลขที่</td>
                        <td className='text-center' style={{minWidth:'110px',width:'110px'}}>ทะเบียนรถ</td>
                        <td className='text-center' style={{minWidth:'100px',width:'100px'}}>ยี่ห้อ</td>
                        <td className='text-center' style={{minWidth:'90px',width:'90px'}}>รุ่น</td>
                        <td className='text-center' style={{minWidth:'150px',width:'150px'}}>ชื่อลูกค้า</td>
                        <td className='text-center' style={{minWidth:'80px',width:'80px'}}>ราคาเสนอ</td>
                        <td className='text-center' style={{minWidth:'80px',width:'80px'}}>ราคาอนุมัติ</td>
                        <td className='text-center' style={{minWidth:'80px',width:'80px'}}>ยอดชำระ</td>
                    </tr>
                    {this.renderRowData(item,index)}
                    {length-1===index?
                    <tr>
                        <td colSpan={8} className='text-right'>ยอดรวมสุทธิ</td>
                        <td className='text-right'>{this.getNumberFormat(this.getSummary('amount'))}</td>
                        <td className='text-right'>{this.getNumberFormat(this.getSummary('approved_amount'))}</td>
                        <td className='text-right'>{this.getNumberFormat(this.getSummary('payment_amount'))}</td>
                    </tr>
                    :''}
                </tbody>
            </table>
        )
    }

    renderComponentPage(item,index,length) {
        return(  
            <div className='font-print' key={index}>
                <header className="text-center">
                    <h2>{this.props.title}</h2>
                </header>
                <div>
                    {this.renderTable(item,index,length)}
                </div>
            </div>
        )    
    }
    
    renderNoData() {
        return(
          <div className='font-print'>
            <header className="text-center">
              <h2>{this.state.report_title}</h2>
            </header>
          </div>
        )
    }

    render() {
        let {loading,dataList} = this.state
        if (dataList.length==0) {
            return(
                <PrintPreview 
                    loading={loading}
                    leftBarTitle={this.props.title}
                    size='landscape'
                >
                    {this.renderNoData()}    
                </PrintPreview>
            )
        } else {
            return(
                <PrintPreview 
                    loading={loading}
                    leftBarTitle={this.props.title}
                    size='landscape'
                >
                    {
                        dataList.map((item,index)=>{
                            return(
                                this.renderComponentPage(item,index,dataList.length)
                            )
                        })   
                    }
                </PrintPreview>
            )
        }      
    }
}

PrintReportPostPayment.defaultProps = {
    title: 'ตารางรายงานสรุปยอดรับเงินแล้ว',
    mode: '',
    workNo: ''
  }
  export default PrintReportPostPayment;


// WEBPACK FOOTER //
// ./src/view/print/finance/PrintReportPostPayment.js